import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button } from 'react-bootstrap';
import useTranslate from 'hooks/useTranslate';

interface CopyButtonProps {
	text: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({ text }: any) => {
	const { translate } = useTranslate();
	const [copied, setCopied] = useState(false);

	const handleCopy = () => {
		setCopied(true);
		setTimeout(() => setCopied(false), 500); // Reset copied state after 2 seconds
	};

	return (
		<div style={{ display: 'inline-flex', alignItems: 'center' }}>
			<CopyToClipboard text={text} onCopy={handleCopy}>
				<Button
					className="edit-btn rounded-circle p-0 border-0"
					aria-label={translate('Common.copyToClipboard') ?? 'Copy to clipboard'}
					title={translate('Common.copyToClipboard') ?? 'Copy to clipboard'}
				>
					<i className="ri-file-copy-line" aria-hidden="true"></i>
				</Button>
			</CopyToClipboard>

			{copied ? (
				<span style={{ color: '#00000090', fontWeight: 600, marginLeft: '10px' }}>
					{translate('Common.copied')}
				</span>
			) : null}
		</div>
	);
};

export default CopyButton;
